export default __webpack_public_path__ + "static/media/2018.d1fa3ccf.mp3";